// extracted by mini-css-extract-plugin
module.exports = {"section-counter":"modalSalesEndHourSessions_section-counter__GdGVT"};